import { FC } from 'react';
import ReserveLedger from './ReserveLedger';
import UseReserveLedger from './UseReserveLedger';

const ReserveLedgerContainer: FC = () => {
  return <ReserveLedger {...UseReserveLedger()} />;
};

export default ReserveLedgerContainer;
